var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { Colors } from "../util/theme";
export var TopBar = function (_a) {
    var titulo = _a.titulo, voltarPara = _a.voltarPara;
    var navigate = useNavigate();
    var handleVoltar = function () {
        if (typeof voltarPara === "string") {
            navigate(voltarPara);
        }
        else if (typeof voltarPara === "function") {
            voltarPara();
        }
    };
    return (_jsx(AppBar, __assign({ position: "static", sx: { width: "100%" } }, { children: _jsxs(Toolbar, __assign({ sx: { backgroundColor: Colors.AZUL_GOV } }, { children: [voltarPara && (_jsx(IconButton, __assign({ size: "large", edge: "start", color: "inherit", onClick: handleVoltar }, { children: _jsx(ArrowBackIcon, {}) }))), _jsx(Typography, __assign({ sx: {
                        flexGrow: 1,
                        textAlign: "center",
                        marginRight: 4,
                    }, fontSize: { xs: "1.25rem", md: "1.5rem" }, fontWeight: { xs: 500, md: 400 } }, { children: titulo }))] })) })));
};
